/* LAIIRA heavy motion layer script. Experimental, lives only in the Heavy motion test theme. */
(function () {
  var d = document;
  var root = d.documentElement;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var fine = window.matchMedia && window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;

  function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function make(cls) {
    var el = d.createElement('div');
    el.className = cls;
    el.setAttribute('aria-hidden', 'true');
    d.body.appendChild(el);
    return el;
  }

  function splitChars(el) {
    if (el.getAttribute('data-lr-chars')) return;
    el.setAttribute('data-lr-chars', '1');
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
    var out = [];
    var i = 0;
    Array.prototype.forEach.call(el.childNodes, function (n) {
      if (n.nodeType === 3) {
        n.textContent.split(/\s+/).filter(Boolean).forEach(function (w) {
          var chars = w.split('').map(function (c) {
            return `<span class='lr-c' aria-hidden='true' style='--i:${i++}'>${esc(c)}</span>`;
          }).join('');
          out.push(`<span class='lr-cw' aria-hidden='true'>${chars}</span>`);
        });
      } else if (n.nodeName === 'BR') {
        out.push('<br>');
      }
    });
    el.innerHTML = out.join(' ');
    el.setAttribute('data-lr-reveal', 'chars');
  }

  function scramble(el) {
    var finalText = el.textContent;
    var pool = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#/';
    var frame = 0;
    var total = 22;
    el.setAttribute('aria-label', finalText);
    var t = setInterval(function () {
      var out = '';
      for (var i = 0; i < finalText.length; i++) {
        if (finalText[i] === ' ') { out += ' '; continue; }
        out += i < (frame / total) * finalText.length ? finalText[i] : pool[Math.floor(Math.random() * pool.length)];
      }
      el.textContent = out;
      if (++frame > total) { clearInterval(t); el.textContent = finalText; }
    }, 40);
  }

  function init() {
    try {
      setTimeout(function () { root.classList.remove('lr-intro'); }, 2400);

      /* Scroll progress bar */
      var bar = make('lr-progress');
      if (!(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'))) {
        window.addEventListener('scroll', function () {
          var h = d.documentElement.scrollHeight - window.innerHeight;
          bar.style.transform = 'scaleX(' + (h > 0 ? window.scrollY / h : 0) + ')';
        }, { passive: true });
      }

      /* Letter-by-letter headings */
      d.querySelectorAll('.lr-drop__heading, .lr-story__heading, .lr-faq__heading').forEach(splitChars);

      /* Scrambling eyebrows when they scroll into view */
      var scrambleIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { scramble(e.target); scrambleIO.unobserve(e.target); }
        });
      }, { threshold: 0.6 });
      d.querySelectorAll('.lr-drop .lr-eyebrow, .lr-story .lr-eyebrow, .lr-faq .lr-eyebrow').forEach(function (el) { scrambleIO.observe(el); });

      /* Wipe reveal on product images */
      var wipeIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); wipeIO.unobserve(e.target); }
        });
      }, { threshold: 0.15 });
      d.querySelectorAll('.card-gallery').forEach(function (g) { g.setAttribute('data-lr-wipe', ''); wipeIO.observe(g); });

      /* Marquee leans with scroll speed */
      var mq = d.querySelector('.lr-marquee');
      if (mq) {
        var last = window.scrollY;
        var skew = 0;
        var loop = function () {
          var y = window.scrollY;
          var target = Math.max(-4, Math.min(4, (y - last) * 0.12));
          last = y;
          skew += (target - skew) * 0.12;
          if (Math.abs(skew) > 0.01) { mq.style.setProperty('--lr-skew', skew.toFixed(3) + 'deg'); }
          else if (mq.style.getPropertyValue('--lr-skew') !== '0deg') { mq.style.setProperty('--lr-skew', '0deg'); }
          requestAnimationFrame(loop);
        };
        loop();
      }

      /* Countdown digits pop */
      d.querySelectorAll('[data-lr-countdown] span').forEach(function (s) {
        new MutationObserver(function () {
          s.classList.remove('lr-tick');
          void s.offsetWidth;
          s.classList.add('lr-tick');
        }).observe(s, { childList: true });
      });

      if (!fine) return;

      /* Film grain */
      make('lr-grain');

      /* Custom cursor */
      var dot = make('lr-cur-dot');
      var ring = make('lr-cur-ring');
      var mx = 0, my = 0, rx = 0, ry = 0, shown = false, mode = '';
      d.addEventListener('mousemove', function (e) {
        mx = e.clientX;
        my = e.clientY;
        if (!shown) { shown = true; rx = mx; ry = my; root.classList.add('lr-cursor-on'); }
        var t = e.target;
        var next = '';
        if (t && t.closest) {
          if (t.closest('.product-card')) next = 'is-view';
          else if (t.closest('a, button, summary, label, input, [role=button]')) next = 'is-hover';
        }
        if (next !== mode) {
          if (mode) ring.classList.remove(mode);
          if (next) ring.classList.add(next);
          mode = next;
        }
      });
      root.addEventListener('mouseleave', function () { root.classList.remove('lr-cursor-on'); shown = false; });
      var follow = function () {
        rx += (mx - rx) * 0.18;
        ry += (my - ry) * 0.18;
        dot.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0)';
        ring.style.transform = 'translate3d(' + rx + 'px,' + ry + 'px,0)';
        requestAnimationFrame(follow);
      };
      follow();

      /* Hero: mouse parallax and spotlight */
      var hero = d.querySelector('.lr-hero');
      if (hero) {
        hero.addEventListener('mousemove', function (e) {
          var r = hero.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width;
          var y = (e.clientY - r.top) / r.height;
          hero.style.setProperty('--mx', ((x - 0.5) * 2).toFixed(3));
          hero.style.setProperty('--my', ((y - 0.5) * 2).toFixed(3));
          hero.style.setProperty('--px', (x * 100).toFixed(1) + '%');
          hero.style.setProperty('--py', (y * 100).toFixed(1) + '%');
        });
        hero.addEventListener('mouseleave', function () {
          hero.style.setProperty('--mx', '0');
          hero.style.setProperty('--my', '0');
        });
      }

      /* Magnetic buttons */
      d.querySelectorAll('.button, .button-secondary').forEach(function (b) {
        b.addEventListener('mousemove', function (e) {
          var r = b.getBoundingClientRect();
          b.style.setProperty('--tx', ((e.clientX - r.left - r.width / 2) * 0.22).toFixed(1) + 'px');
          b.style.setProperty('--ty', ((e.clientY - r.top - r.height / 2) * 0.35).toFixed(1) + 'px');
        });
        b.addEventListener('mouseleave', function () {
          b.style.setProperty('--tx', '0px');
          b.style.setProperty('--ty', '0px');
        });
      });

      /* Product cards: 3D tilt */
      d.querySelectorAll('.product-card').forEach(function (card) {
        var g = card.querySelector('.card-gallery');
        if (!g) return;
        card.addEventListener('mousemove', function (e) {
          var r = g.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          g.style.setProperty('--ry', (x * 10).toFixed(2) + 'deg');
          g.style.setProperty('--rx', (-y * 10).toFixed(2) + 'deg');
        });
        card.addEventListener('mouseleave', function () {
          g.style.setProperty('--rx', '0deg');
          g.style.setProperty('--ry', '0deg');
        });
      });
    } catch (err) { /* motion is optional, never break the page */ }
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
